import React from 'react';
import { Icon } from './Icon.js';
export const IconFolderCheck = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M15 18L17 20L22 15", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M13.4141 5H23V10.4639L21 12.4639V7H12.5859L9.58594 4H3V19H11.7607L13.7607 21H1V2H10.4141L13.4141 5Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconFolderCheck.js.map